module.exports = __webpack_public_path__ + "static/img/end.f35a47f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/RoundMove/end.jpg
// module id = RAS3
// module chunks = 1